import { collection, doc, getDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { Tag } from "../types";
import { TagDB } from "./Tags";

export const getTagDetails = async (tagId: string): Promise<Tag> => {
  const collectionRef = collection(db, "tags");

  const tagSnapshot = await getDoc(doc(collectionRef, tagId));

  return new TagDB(tagSnapshot).toTag();
};
